import React, { useContext } from 'react';
import { Menu, Eye } from 'lucide-react';
import logoLong from "../assets/logos/logo-long.png"
import imgDefault from "../assets/logos/logo-fin.png";
import AppContext from '../Context/AppContext';

const Header = ({ onToggleMenu = () => { } }) => {
    const { setSideSheetOpen } = useContext(AppContext)

    return (
        <>
            <header className='header'>
                <div className='df aic gap1'>
                    <button onClick={onToggleMenu} className='hamburger only-mobile'>
                        <Menu size={22} color='#fff' />
                    </button>
                    <a>
                        <img className='logo-long' src={logoLong}></img>
                    </a>
                </div>
                <div className='df aic gap1'>
                    <button onClick={() => setSideSheetOpen(true)} className='hamburger only-mobile'>
                        <Eye size={22} color='#fff' />
                    </button>
                    <div className='logo-user'>
                        <img src={imgDefault}></img>
                    </div>
                </div>
            </header>
        </>
    );
};

export default Header;